import 'css-chunksrc/client/pages/projectPage/synthesisPage/pdfExport/form/styles.scss';export default {
  "form": "_form_qigp7_1",
  "header": "_header_qigp7_13",
  "main": "_main_qigp7_24",
  "object": "_object_qigp7_31",
  "title": "_title_qigp7_36",
  "label": "_label_qigp7_43",
  "limitIndicator": "_limitIndicator_qigp7_49",
  "input": "_input_qigp7_55",
  "group": "_group_qigp7_64",
  "row": "_row_qigp7_68",
  "reportPlaceholder": "_reportPlaceholder_qigp7_76",
  "buttons": "_buttons_qigp7_84",
  "link": "_link_qigp7_93"
};